module.exports = __webpack_public_path__ + "static/media/Icon Select.a0a45965.svg";